import type { LegacyStats, Space } from '../types';
import type { MainTab } from './BottomNav';

type FeaturedProps = {
  space?: Space;
  stats: LegacyStats;
  onNavigate: (tab: MainTab) => void;
  onOpen: (space: Space) => void;
};

export function FeaturedRoomCard({space,stats,onNavigate,onOpen}: FeaturedProps) {
  return <article className="room-card featured" style={{ backgroundImage:'url(/api/media.php?action=hero)' }}>
    <div className="room-shade"/>
    <span className="room-badge"><i/>Dein Raum</span>
    <div className="room-content">
      <small>UCKERMARK · 11.–16. JULI 2026</small>
      <h2>{space?.title || 'Summerintensiv 2026'}</h2>
      <p>{space?.summary || 'Was in diesen Tagen entstanden ist, bleibt als lebendiger gemeinsamer und persönlicher Raum zugänglich.'}</p>
      <div className="metrics">
        <button type="button" onClick={() => onNavigate('together')}><strong>{stats.moments}</strong><span>Momente</span></button>
        <button type="button" onClick={() => onNavigate('treasures')}><strong>{stats.treasures}</strong><span>Schätze</span></button>
        <button type="button" aria-label={`${stats.images} Bilder in der bestehenden App`} onClick={() => location.assign('/#photos')}><strong>{stats.images}</strong><span>Bilder</span></button>
      </div>
      <button className="room-action" type="button" disabled={!space} onClick={() => space && onOpen(space)}>In den Raum <b>→</b></button>
    </div>
  </article>;
}

export function SecondaryRoomCard({space,onOpen}:{space:Space;onOpen:(space:Space)=>void}) {
  return <article className="room-card secondary" style={space.cover_url ? {backgroundImage:`url(${space.cover_url})`} : undefined}>
    <div className="room-shade"/>
    <span className="room-badge"><i/>{space.visibility === 'paid' ? 'Mit Zugang' : 'Dein Raum'}</span>
    <div className="room-content">
      <small>{space.space_type.toUpperCase()}</small><h2>{space.title}</h2><p>{space.summary}</p>
      <div className="metrics"><span><strong>{space.stats?.members || 0}</strong><em>Menschen</em></span><span><strong>{space.stats?.content || 0}</strong><em>Inhalte</em></span><span><strong>{space.stats?.upcoming_events || 0}</strong><em>Termine</em></span></div>
      <button className="room-action" type="button" onClick={() => onOpen(space)}>Raum ansehen <b>→</b></button>
    </div>
  </article>;
}
